import type { CSSProperties } from 'react';
import type { troupeCall } from './troupeCall.js';

/**
 * TroupeCTA — "Can't get a group? / Fill in with AI opponents".
 *
 * ONE component for the phone and desktop lobbies (never two near-copies), and
 * the ONE place the AI-seat offer is worded.
 *
 * It takes the slot the curtain button occupies, and below the player floor it
 * REPLACES it — owner, on PR #45: "hide the Raise the curtain button and
 * instead move there the link to call in the troupe … the button needs to be
 * more prominent". A text link under three other lines was not being seen.
 *
 * Two parts on purpose, and only two lines: a plain question a stuck host
 * recognises, and the bold control that answers it. The setup line also does
 * the work the removed stall-nudge line used to do, which is why the nudge
 * drops its own when this is on screen — the same sentence three times over
 * ("need 4 more", "an empty house", "can't get a group") is the "5 lines of
 * text" the owner called out.
 *
 * The button skin comes from the CALLER, because the two surfaces have
 * different secondary idioms (`fixedSecondaryButtonStyle` on the phone,
 * `desktopGhostBtn` in the Activity) and inventing a third look here is exactly
 * what the consistency rule forbids. Secondary, not primary: the invite below
 * it keeps the surface's single primary (issue #29).
 */
export function TroupeCTA({
  call,
  buttonStyle,
  style,
}: {
  /** The action from `troupeCall` — null when there is nothing to offer. */
  call: NonNullable<ReturnType<typeof troupeCall>>;
  /** The surface's own secondary-button skin. */
  buttonStyle: CSSProperties;
  style?: CSSProperties;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'var(--space-2)',
        width: '100%',
        ...style,
      }}
    >
      <p
        style={{
          margin: 0,
          fontFamily: 'var(--font-ui)',
          fontSize: 13,
          color: 'var(--text-tertiary)',
          textAlign: 'center',
        }}
      >
        Can&rsquo;t get a group?
      </p>
      <button type="button" className="rm-hover-pill" onClick={call.onCall} style={buttonStyle}>
        {call.label}
      </button>
    </div>
  );
}
